import { SvgIcon, SvgIconProps } from "@mui/material";

/**
 * Line icons for the ticket detail screen. The Settings design draws each as an
 * inline stroked SVG rather than a Material glyph, so the shapes live here.
 *
 * All of them inherit `currentColor`; size comes from the caller's `sx`.
 */

const strokeProps = {
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round" as const,
  strokeLinejoin: "round" as const,
  strokeWidth: 2,
};

/** Leads the "Back to tickets" link. */
export const BackArrowIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <path {...strokeProps} d="M19 12H5m0 0 6-6m-6 6 6 6" />
  </SvgIcon>
);

/** Document with a folded corner — the description's attachment chips. */
export const FileIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <path
      {...strokeProps}
      strokeWidth={1.8}
      d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8z"
    />
    <path {...strokeProps} strokeWidth={1.8} d="M14 3v5h5" />
  </SvgIcon>
);

/** Tray with a down arrow — download an attachment. */
export const DownloadIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <path {...strokeProps} strokeWidth={1.9} d="M12 4v10m0 0 4-4m-4 4-4-4" />
    <path
      {...strokeProps}
      strokeWidth={1.9}
      d="M4 17v1a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-1"
    />
  </SvgIcon>
);

/** Paperclip — attachments on a comment, and the editor's attach control. */
export const PaperclipIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <path
      {...strokeProps}
      strokeWidth={1.9}
      d="M21 12.5 12.6 21a5 5 0 0 1-7-7l8-8a3.4 3.4 0 0 1 4.8 4.8l-8 8a1.8 1.8 0 0 1-2.5-2.5l7.3-7.3"
    />
  </SvgIcon>
);
